import BackArrowIcon from "assets/icons/BackArrowIcon";
import WhatsUpIcon from "assets/icons/WhatsUpIcon";
import { getSymbol } from "utils/functions";
import { sendMessage } from "../config";

const LimitSwiperCard = ({
  planData,
  limitData,
  profile,
  header = "Basic",
  colors,
  checkAll = true,
}) => {
  const handleOpenWhatsUpp = () => {
    sendMessage("I want to learn more about service plans");
  };
  return (
    <div
      className={`p-5  border-[1px]  mx-5 rounded-2xl  `}
      style={{
        background: colors?.bg || "#f9fcf5",
        borderColor: colors?.border || "#8cc63e",
      }}
    >
      <div className="pb-[100px]">
        <div className="flex flex-col gap-5">
          <p className="text-center text-3xl font-bold">{header}</p>
          <div
            className={`rounded-xl  p-[10px]`}
            style={{
              background: colors?.bgDark || "#f4f9ec",
            }}
          >
            <div className="flex justify-between pb-[10px]">
              <p className="text-[#59506e] font-bold">Monthly limit</p>
              <p className="text-[#170738] font-bold truncate overflow-hidden whitespace-nowrap">
                {limitData?.monthlyLimit &&
                  limitData?.monthlyLimit?.toLocaleString()}
                {profile?.currency && getSymbol(profile?.currency)}
              </p>
            </div>
            <p className="text-[#59506e] font-bold text-lg">Transaction fee</p>
            <div className="grid">
              {planData?.currentPlanDetails?.commissions?.map((fee) => {
                if (
                  fee?.acquiringType === "APPLE_PAY" ||
                  fee?.acquiringType === "GOOGLE_PAY" ||
                  fee?.acquiringType === "INSTALLMENT"
                ) {
                  return null;
                } else {
                  return (
                    <InfoRow
                      heading={fee?.acquiringType}
                      info={`${fee?.senderCommission}%`}
                    />
                  );
                }
              })}
            </div>
          </div>
        </div>
        <div className="pt-5 flex flex-col gap-[10px]">
          {servicePlans(checkAll).map((el) => {
            const cancelIcon = shouldUseCancel.some((item) => item === el);
            return (
              <div className="flex items-center gap-[10px]">
                <img
                  src={
                    cancelIcon && !checkAll
                      ? "/svg/cancel.svg"
                      : "/svg/greenCheck.svg"
                  }
                  alt="check"
                />
                <p className="text-[#888196]">{el}</p>
              </div>
            );
          })}
        </div>
      </div>
      {header === "Business" &&
        planData?.currentPlanDetails?.groupName === "Premium" && (
          <div
            className="flex justify-between items-center pr-[10px]  bg-[#f1f0ff] rounded-lg cursor-pointer"
            onClick={handleOpenWhatsUpp}
          >
            <div className="flex items-center">
              <WhatsUpIcon bg="none" fill="#6C63FF" className="w-10" />
              <p className="text-primary-main">
                Have a question? Talk to sales
              </p>
            </div>

            <BackArrowIcon className="rotate-180" color="#aea9ff" />
          </div>
        )}
    </div>
  );
};

export default LimitSwiperCard;

const InfoRow = ({ heading, info }) => {
  const header =
    heading === "STANDARD"
      ? "Bank cards"
      : heading === "CRYPTO"
      ? "Crypto"
      : heading === "OB"
      ? "Online bank"
      : "";
  return (
    <div className="flex justify-between overflow-hidden h-5 ">
      <p className="text-sm whitespace-nowrap pr-[5px] text-[#59506e]">
        {header}
      </p>
      <p className="text-[#170738] text-sm font-bold truncate overflow-hidden whitespace-nowrap ">
        {info}
      </p>
    </div>
  );
};
const servicePlans = (isBasic) => [
  "Tips",
  "Feedback & rating system",
  isBasic ? "Multi branch" : "Single branch",
  "International bank cards",
  "Merchant dashboard",
  "API Integration",
];
const shouldUseCancel = [
  "International bank cards",
  "Merchant dashboard",
  "API Integration",
];
